var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.ready
        ? _c("data-table", {
            ref: "table",
            staticClass: "table table-striped",
            attrs: {
              columns: _vm.columns,
              data: _vm.issues,
              loading: _vm.loading,
              options: { edit: { enabled: true, iconButton: true } }
            },
            on: {
              edit: function($event) {
                return _vm.startEdit($event)
              },
              comments: function($event) {
                return _vm.loadComments($event)
              },
              external: function($event) {
                return _vm.linkToJira($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.users && _vm.issueToEdit
        ? _c("edit", {
            attrs: { issue: _vm.issueToEdit, users: _vm.users },
            on: {
              "update-issue": function($event) {
                return _vm.updateIssue($event)
              },
              "stop-edit": function($event) {
                return _vm.stopEdit()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.users
        ? _c("comments", { ref: "comments", attrs: { users: _vm.users } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }